import placeholder from '../../../assets/resources/optimized-images/user.png';

export default function useAuthorPlaceholderImage() {
  // there was a query before, but it shouldn't. so now we just pretend to use ImageSharp
  // NOTE: move useAuthor... to another directory.
  return { fixed: {src: placeholder }};
}
